// Third-party packages
import {
	createSelector,
} from '@reduxjs/toolkit';

// Project modules
import {
	ReducerInstance,
} from '@stores/lpdipro/reducers';
import {
	RootState,
} from '@stores/lpdipro/store';

export const selectUserState = (state: RootState & ReducerInstance) => state.user;

export const selectUserToken = createSelector(
	selectUserState,
	(state) => state.token,
);

export const selectUserCompanyBrokers = createSelector(
	selectUserState,
	(state) => state?.company?.brokers ?? {
		collection: [],
		count: 0,
	},
);

export const selectUserCompanyDocumentTemplates = createSelector(
	selectUserState,
	(state) => state?.company?.document_templates ?? {
		collection: [],
		count: 0,
	},
);